import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import React from 'react';
import { withStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { styles } from '../../theme/styles';
import cherriskhu from '../../assets/images/cherrisk/400x400-AYCM-DokiApp-banner.png';
import cherrisken from '../../assets/images/cherrisk/400x400-AYCM-DokiApp-banner-eng.png';

const CherriskPopup = props => {
  const { classes, handleClose, showError } = props;

  const { i18n } = useTranslation();

  const getBackgroundImage = () => {
    switch (i18n.language) {
      case 'hu':
        return cherriskhu;
      case 'en':
        return cherrisken;
      default:
        return cherriskhu;
    }
  };

  const handleClick = () => {
    const url = `https://employeecare.hu/aycm-b2c${
      i18n.language === 'en' ? '-en' : ''
    }/?utm_source=aycm&utm_medium=banner&utm_campaign=dokiapp&utm_id=aycm-b2c${
      i18n.language === 'en' ? '-en' : ''
    }`;
    window.open(url, '_blank');
    handleClose();
  };

  const backgroundImage = getBackgroundImage();
  return (
    <Dialog onClose={handleClose} open={showError}>
      <IconButton
        aria-label="close"
        onClick={handleClose}
        style={{
          position: 'absolute',
          zIndex: '100',
          right: '8px',
          top: '8px',
          color: 'white'
        }}>
        <CloseIcon />
      </IconButton>
      <DialogContent
        className={classes.cherriskPopup}
        style={{
          background: `url(${backgroundImage})`,
          backgroundSize: 'contain',
          backgroundRepeat: 'no-repeat'
        }}>
        <div
          className={classes.cherriskPopupButton}
          onClick={handleClick}
          onKeyUp={handleClick}
          role="button"
          tabIndex={0}
          aria-label="Open Link"
        />
      </DialogContent>
    </Dialog>
  );
};

CherriskPopup.propTypes = {
  classes: PropTypes.shape().isRequired,
  handleClose: PropTypes.func.isRequired,
  showError: PropTypes.bool.isRequired
};
export default withStyles(styles)(CherriskPopup);
